import React from 'react'
import '../accountLoginTab/AccountLoginTab.css'

const AccountLoginTab = () => {
  return (
    
    <div className='tabs-detail-sec account-login-tab'>
        <form action="">
            <div className='account-box'>
                <h2>Private Information</h2>
                <div className='account-login-content-details'>
                    <div className='form-group'>
                        <input type="text" className="form-control" id="" placeholder="First name" />
                    </div>
                    <div className='form-group'>
                        <input type="text" className="form-control" id="" placeholder="Last name" />
                    </div>
                    <div className='form-group'>
                        <input type="email" className="form-control" id="" placeholder="Email" />
                    </div>
                    <div className='form-group'>
                        <input type="text" className="form-control" id="" placeholder="Phone number" />
                    </div>
                </div>
            </div>
        </form>
    </div>
  )
}

export default AccountLoginTab
